const screens = {
    extraSmall: '360px',
    small: '400px',
    medium: '950px',
    large: '1200px'
}
export default screens
